// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the office-online-interface-gen tool.
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------


// For ScriptSharp to work, this code must be exported from a webpack chunk called 'healthSmall', and so emitted as 'var healthSmall = ...'

/* tslint:disable */

export type nullable = null | undefined; // ScriptSharp conflates these

export enum KpiType {
  FailureBased = 0,
  SuccessBased = 1,
}

/**
 * Additional values for QoS and KPI events
 */
export interface AdditionalValues {
  ['durationMs']?: number | nullable;
  ['inStaging']?: boolean | nullable;
  ['extendedProperties']?: Map<string | nullable, string | nullable> | nullable;
}

/**
 * Health configuration information
 */
export interface HealthConfig {
  ['absoluteRemoteTelemetryUrlForOfflineWorker']?: string | nullable;
  ['dimensions']?: HealthDimensions | nullable;
  ['disabledHealthEvents']?: Set<string | nullable> | nullable;
  ['heartbeatIntervalMs']?: number | nullable;
  ['isFetchApiEnabled']?: boolean | nullable;
  ['isHealthEnabled']?: boolean | nullable;
  ['isOfflineEnabled']?: boolean | nullable;
  ['isErrorPartCEnabled']?: boolean | nullable;
  ['loggerMaxIntervalMs']?: number | nullable;
  ['loggerMaxQueueSize']?: number | nullable;
  ['maxConcurrentRetries']?: number | nullable;
  ['offlineWorkerUrl']?: string | nullable;
  ['recordPillarToWarmPipelineIntervalMs']?: number | nullable;
  ['remoteTelemetryUrl']?: string | nullable;
  ['retryDelayMs']?: number | nullable;
  ['retryMaxAttempts']?: number | nullable;
}

/**
 * Session dimensions used when sending Aria/MDM events via our RemoteTelemetry endpoint
 */
export interface HealthDimensions {
  ['allowEarlyFeatures']?: boolean | nullable;
  ['application']?: string | nullable;
  ['applicationLcid']?: string | nullable;
  ['applicationMode']?: string | nullable;
  ['applicationModeExtended']?: string | nullable;
  ['arrVersion']?: string | nullable;
  ['browser']?: string | nullable;
  ['browserLcid']?: string | nullable;
  ['browserMajorVersion']?: string | nullable;
  ['browserVersion']?: string | nullable;
  ['clientVersion']?: string | nullable;
  ['datacenter']?: string | nullable;
  ['dataCulture']?: string | nullable;
  ['fileExtension']?: string | nullable;
  ['flightsImpressionId']?: string | nullable;
  ['host']?: string | nullable;
  ['isAnonymousUser']?: boolean | nullable;
  ['isBusinessUser']?: boolean | nullable;
  ['isEduUser']?: boolean | nullable;
  ['isSynthetic']?: boolean | nullable;
  ['loggableUserId']?: string | nullable;
  ['loggableUserIdSpace']?: string | nullable;
  ['networkDownlink']?: number | nullable;
  ['networkDownlinkMax']?: number | nullable;
  ['networkEffectiveType']?: string | nullable;
  ['networkRTT']?: number | nullable;
  ['networkSaveData']?: boolean | nullable;
  ['networkType']?: string | nullable;
  ['osVersion']?: string | nullable;
  ['ring']?: string | nullable;
  ['serverDocId']?: string | nullable;
  ['session_id']?: string | nullable;
  ['sessionOrigin']?: string | nullable;
  ['tenantId']?: string | nullable;
  ['uiHost']?: string | nullable;
  ['uiHostIntegrationType']?: string | nullable;
  ['userLicenseType']?: string | nullable;
  ['wfeVersion']?: string | nullable;
}

export interface IKpiUsageOptionalProperties {
  ['extendedProperties']?: Map<string | nullable, string | nullable> | nullable;
  ['isForAlertableKpi']?: boolean | nullable;
}

export interface IKpiFailureOptionalProperties {
  ['isIntentional']?: boolean | nullable;
  ['isInternal']?: boolean | nullable;
  ['additionalValues']?: AdditionalValues | nullable;
  ['hasImpliedUsage']?: boolean | nullable;
}

export interface IKpiSuccessOptionalProperties {
  ['additionalValues']?: AdditionalValues | nullable;
  ['hasImpliedUsage']?: boolean | nullable;
}

export interface IQosErrorOptionalProperties {
  ['errorNameOverride']?: string | nullable;
  ['isIntentional']?: boolean | nullable;
  ['isInternal']?: boolean | nullable;
  ['alertOnPillar']?: boolean | nullable;
  ['isSessionEndingError']?: boolean | nullable;
  ['additionalValues']?: AdditionalValues | nullable;
}

export interface OptionalVetoType extends IQosErrorOptionalProperties {
  ['name']?: string | nullable;
}

export interface KpiUsageParams {
  ['kpiName']?: string | nullable;
  ['kpiType']: KpiType;
  ['optionalProperties']?: IKpiUsageOptionalProperties | nullable;
  ['blockFutureEmissionDurationInMs']?: number | nullable;
}

export interface KpiFailureParams {
  ['kpiName']?: string | nullable;
  ['errorName']?: string | nullable;
  ['optionalProperties']?: IKpiFailureOptionalProperties | nullable;
  ['optionalVeto']?: OptionalVetoType | nullable;
  ['blockFutureEmissionDurationInMs']?: number | nullable;
}

export interface KpiSuccessParams {
  ['kpiName']?: string | nullable;
  ['optionalProperties']?: IKpiSuccessOptionalProperties | nullable;
  ['blockFutureEmissionDurationInMs']?: number | nullable;
}

/**
 * Configuration of a feature so it can be monitored by ExtendedHealth
 */
export interface FeatureUsageAndHealthConfig {
  /**
   * Name of feature's top-level KPI usage event name (feature-level denominator) that is logged max once per session per day
   */
  ['topLevelKpiName']?: string | nullable;
  /**
   * Name of feature that is appended as a column to all KPIs and vetoes
   */
  ['featureName']?: string | nullable;
  /**
   * Name of feature's crew
   */
  ['crewAlias']?: string | nullable;
  /**
   * Name of feature's top-level Veto pillar
   */
  ['vetoPillar']?: string | nullable;
  /**
   * Name of feature area (preferrably same name as top-level Veto pillar if applicable)
   */
  ['areaName']?: string | nullable;
  /**
   * Flag to not emit aggregated counts when throttling KPI logs
   */
  ['doNotEmitAggregatedCount']?: boolean | nullable;
}

/**
 * Part of CallbackLoggingParams type (see below) that enforces KPI usage-related params
 */
export interface KpiUsageLoggingParams {
  /**
   * KPI usage to be logged BEFORE the callback is executed
   */
  ['usageName']?: string | nullable;
  /**
   * Type of KPI usage (e.g. failure-based)
   */
  ['usageKpiType']: KpiType;
  /**
   * Optional properties of KPI usage
   */
  ['usageOptionalProperties']?: IKpiUsageOptionalProperties | nullable;
}

/**
 * Part of CallbackLoggingParams type (see below) that enforces KPI success-related params
 */
export interface KpiSuccessLoggingParams {
  /**
   * KPI usage to be logged BEFORE the callback is executed
   */
  ['usageName']?: string | nullable;
  /**
   * Type of KPI usage (e.g. failure-based)
   */
  ['usageKpiType']: KpiType;
  /**
   * Optional properties of KPI usage
   */
  ['usageOptionalProperties']?: IKpiUsageOptionalProperties | nullable;
  /**
   * Optional properties of KPI success
   */
  ['successOptionalProperties']?: IKpiSuccessOptionalProperties | nullable;
}

/**
 * Part of CallbackLoggingParams type (see below) that enforces KPI failure-related params
 */
export interface KpiFailureLoggingParams {
  /**
   * KPI usage to be logged BEFORE the callback is executed
   */
  ['usageName']?: string | nullable;
  /**
   * Type of KPI usage (e.g. failure-based)
   */
  ['usageKpiType']: KpiType;
  /**
   * Optional properties of KPI usage
   */
  ['usageOptionalProperties']?: IKpiUsageOptionalProperties | nullable;
  /**
   * KPI failure to be logged IFF the callback throws an error
   */
  ['failureErrorName']?: string | nullable;
  /**
   * Optional properties of KPI failure
   */
  ['failureOptionalProperties']?: IKpiFailureOptionalProperties | nullable;
}

/**
 * Part of CallbackLoggingParams type (see below) that enforces QOS veto-related params
 */
export interface VetoFailureLoggingParams {
  /**
   * KPI usage to be logged BEFORE the callback is executed
   */
  ['usageName']?: string | nullable;
  /**
   * Type of KPI usage (e.g. failure-based)
   */
  ['usageKpiType']: KpiType;
  /**
   * Optional properties of KPI usage
   */
  ['usageOptionalProperties']?: IKpiUsageOptionalProperties | nullable;
  /**
   * KPI failure to be logged IFF the callback throws an error
   */
  ['failureErrorName']?: string | nullable;
  /**
   * Optional properties of KPI failure
   */
  ['failureOptionalProperties']?: IKpiFailureOptionalProperties | nullable;
  /**
   * QOS veto to be logged IFF the callback throws an error
   */
  ['vetoName']?: string | nullable;
  /**
   * Optional properties of QOS veto
   */
  ['vetoOptionalProperties']?: IQosErrorOptionalProperties | nullable;
}

/**
 * Logging configuration that defines which events need to be instrumented around the wrapped callback
 */
export interface CallbackLoggingParams {
  ['kpiUsageLoggingParams']?: KpiUsageLoggingParams | nullable;
  ['kpiSuccessLoggingParams']?: KpiSuccessLoggingParams | nullable;
  ['kpiFailureLoggingParams']?: KpiFailureLoggingParams | nullable;
  ['vetoFailureLoggingParams']?: VetoFailureLoggingParams | nullable;
}

export interface IHealth {
  /**
   * Attempts to add or update a single part C dimension value
   */
  ['addOrUpdatePartCDimension']: (dimension: string | nullable, value: string | nullable) => void;
  /**
   * Attempts to add or update a single part C dimension value, which will be only send with error events
   */
  ['addOrUpdateErrorPartCDimension']: (dimension: string | nullable, value: string | nullable) => void;
  /**
   * Add pillar
   */
  ['addQosPillar']: (pillarName: string | nullable) => void;
  /**
   * Records a bSQM QoS error
   */
  ['recordBsqmQosError']: (bsqmErrorId: string | nullable, additionalVetoes: (string | nullable)[] | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a kpi failure
   */
  ['recordKpiFailure']: (kpiName: string | nullable, errorName: string | nullable, isIntentional: boolean | nullable, isInternal: boolean | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a kpi failure, where the usage is implied
   */
  ['recordKpiImpliedFailure']: (kpiName: string | nullable, errorName: string | nullable, isIntentional: boolean | nullable, isInternal: boolean | nullable, owningFeatureCrewAlias: string | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a kpi success, where the usage is implied
   */
  ['recordKpiImpliedSuccess']: (kpiName: string | nullable, owningFeatureCrewAlias: string | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a kpi success
   */
  ['recordKpiSuccess']: (kpiName: string | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a kpi usage
   */
  ['recordKpiUsage']: (kpiName: string | nullable, kpiType: KpiType, owningFeatureCrewAlias: string | nullable, extendedProperties: Map<string | nullable, string | nullable> | nullable) => void;
  /**
   * Record a kpi usage for an alertable kpi
   */
  ['recordKpiUsageForAlertableKpi']: (kpiName: string | nullable, owningFeatureCrewAlias: string | nullable, extendedProperties: Map<string | nullable, string | nullable> | nullable) => void;
  /**
   * Record a qos error
   */
  ['recordQosError']: (errorName: string | nullable, vetoes: (string | nullable)[] | nullable, isIntentional: boolean | nullable, isInternal: boolean | nullable, alertOnPillar: boolean | nullable, isSessionEndingError: boolean | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Record a qos error for copilot specific scenarios
   */
  ['recordQosErrorForCopilot']: (copilotInteractionId: string | nullable, errorName: string | nullable, vetoes: (string | nullable)[] | nullable, isIntentional: boolean | nullable, isInternal: boolean | nullable, alertOnPillar: boolean | nullable, isSessionEndingError: boolean | nullable, additionalValues: AdditionalValues | nullable) => void;
  /**
   * Remove pillar
   */
  ['removeQosPillar']: (pillarName: string | nullable) => void;
  /**
   * If timers were previously stopped, resumes the timers
   */
  ['resumeAllHealthTimers']: () => void;
  /**
   * Set a callback we can use to tell whether the app is shutting down
   */
  ['setHandlerForIsAppShuttingDown']: (isAppShuttingDown: (() => boolean) | nullable) => void;
  ['setIsAppOnline']: (isAppOnline: boolean) => void;
  /**
   * Stop health timers, if they are currently running
   */
  ['stopAllHealthTimers']: () => void;
  /**
   * Flushes the RemoteTelemetryLogger to send out any outstanding events
   */
  ['shutdown']: () => void;
  /**
   * Updates Part A dimension(s)
   */
  ['updatePartADimensions']: (partADimensions: HealthDimensions | nullable) => void;
}

export interface IFeatureUsageAndHealthLogger {
  /**
   * Logs a usage KPI
   */
  ['logKpiUsage']: (kpiName: string | nullable, kpiType: KpiType, optionalProperties: IKpiUsageOptionalProperties | nullable, blockFutureEmissionDurationInMs: number) => boolean;
  /**
   * Logs a failure for the provided usage KPI
   */
  ['logKpiFailure']: (kpiName: string | nullable, errorName: string | nullable, optionalProperties: IKpiFailureOptionalProperties | nullable, optionalVeto: OptionalVetoType | nullable, blockFutureEmissionDurationInMs: number) => boolean;
  /**
   * Logs a success for the provided usage KPI
   */
  ['logKpiSuccess']: (kpiName: string | nullable, optionalProperties: IKpiSuccessOptionalProperties | nullable, blockFutureEmissionDurationInMs: number) => boolean;
  /**
   * Ensures that this feature's top-level usage KPI (denominator) was logged and its veto pillar registered
   */
  ['ensureFeatureDenominatorLoggedAndVetoPillarRegistered']: (optionalProperties: IKpiUsageOptionalProperties | nullable) => void;
}

export interface IExtendedHealth {
  /**
   * Logs a usage KPI
   */
  ['logKpiUsage']: (kpiUsageParams: KpiUsageParams | nullable) => boolean;
  /**
   * Logs a failure for the provided usage KPI
   */
  ['logKpiFailure']: (kpiFailureParams: KpiFailureParams | nullable) => boolean;
  /**
   * Logs a success for the provided usage KPI
   */
  ['logKpiSuccess']: (kpiSuccessParams: KpiSuccessParams | nullable) => boolean;
  /**
   * Ensures that this feature's top-level usage KPI (denominator) was logged and its veto pillar registered
   */
  ['ensureFeatureDenominatorLoggedAndVetoPillarRegistered']: (optionalProperties: IKpiUsageOptionalProperties | nullable) => void;
  /**
   * Helper function to log KPIs that surrounds the execution of a callback
   */
  ['executeCallbackWithLogging']: (callback: (() => void) | nullable, loggingParams: CallbackLoggingParams | nullable) => void;
}

export interface IHealthFactory {
  /**
   * Gets an instance of Health
   */
  ['getHealthInstance']: (healthConfig: HealthConfig | nullable) => IHealth | nullable;
  /**
   * Gets an instance of ExtendedHealth
   */
  ['getExtendedHealthInstance']: (healthLogger: IHealth | nullable, featureConfig: FeatureUsageAndHealthConfig | nullable) => IExtendedHealth | nullable;
}

import { HealthFactory as HealthFactoryImpl } from '../healthFactory';
export const HealthFactoryGlobal: IHealthFactory = new HealthFactoryImpl();
